<div *ngIf="init">
  <div
    *ngIf="!embeddedInQuotation"
    [class.collapsed]="collapsed"
    class="section-header padding d-flex  overflowHidden clickable"
    (click)="collapsed = !collapsed"
    [attr.aria-expanded]="!collapsed"
  >
    <div class="details-text flexer">
      Details factuur
    </div>
    <button
      mat-icon-button
      class="arrow-button pull-right"
      style="margin-top:5px"
    >
      <mat-icon svgIcon="arrow-up"></mat-icon>
    </button>
  </div>
  <div [collapse]="collapsed" [isAnimated]="!safari">
    <br />

    <div *ngFor="let invoice of invoices; let index = index">
      <div class="form-title bold-title">
        {{ invoice.company.regularName }}
      </div>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Referentienummer"
          [(ngModel)]="invoice.referenceNumber"
          name="referenceNumberInput"
          (ngModelChange)="referenceNumberChanged()"
        />
      </mat-form-field>
      <ng-container *ngIf="repoPriceLines.has(invoice.company.id)">
        <ng-container
          *ngFor="let repoPriceLine of repoPriceLines.get(invoice.company.id)"
        >
          <price-line-input
            *ngIf="repoPriceLine.price != null && repoPriceLine.price > 0"
            [priceLine]="repoPriceLine"
            [disablePriceEdit]="true"
          ></price-line-input>
        </ng-container>
      </ng-container>
      <price-line-picker
        [inputList]="invoice.priceLines"
        [alignWithBoardPrices]="true"
        (output)="setPrices($event, index)"
      ></price-line-picker>
    </div>

    <ng-container *ngIf="!embeddedInQuotation">
      <div class="form-title bold-title">
        Nazicht
      </div>

      <textarea-input
        [title]="'Opmerkingen facturatie uit offerte'"
        [placeholder]="
          'Geef extra informatie over de ' + getFormDisplayNameLowerCase()
        "
        [initContent]="inputAdjustment.extraInfoInvoice"
        (answer)="extraInfoChange($event)"
      ></textarea-input>

      <div class="form-sub-title">Feedback installateur</div>
      <p class="preserve-line-break">{{ displayPlacerFeedback() }}</p>

      <p *ngIf="inputAdjustment.splitCosts" class="italics-text">
        De kosten worden verdeeld over de partners
      </p>

      <mat-checkbox
        [(ngModel)]="inputAdjustment.readyToInvoice"
        (ngModelChange)="readyToInvoiceChange()"
        >Klaar voor facturatie</mat-checkbox
      >

      <div class="send-button">
        <button
          type="button"
          (click)="sendInvoice(true)"
          mat-button
          class="button"
          [disabled]="
            !canInvoice() || sendingInvoice || loadingService.getIsSaving()
          "
          id="btnSendInvoice"
        >
          {{ getSendButtonLabel() }}
        </button>
      </div>

      <div *ngIf="isTestEnvironment()" class="send-button">
        <button
          type="button"
          (click)="sendInvoice(false)"
          mat-button
          class="button"
          id="btnSimulateSendInvoice"
        >
          Simuleer aanmaak factuur
        </button>
      </div>

      <br />

      <div *ngIf="anySentToTeamleader">
        <div class="form-title bold-title">
          Link naar factuur in Teamleader
        </div>

        <ul class="list-top">
          <div *ngFor="let invoice of invoices">
            <div *ngIf="invoice.teamleaderId != null">
              <li>
                <a
                  href="https://app.teamleader.eu/invoice_detail.php?id={{
                    invoice.teamleaderId
                  }}"
                  target="_blank"
                  >{{ getLinkText(invoice) }}</a
                >
              </li>
            </div>
          </div>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
